import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {FulfillmentLineType} from "../../../oms/types/fulfillment-line.type";
import {AddressesService} from "../../../addresses/services/addresses-service.factory";
import {CustomersDialogService} from "../../../customers/services/customers-dialogs-service.service";
import {CustomerService} from "../../../customers/services/customers-service.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {FulfillmentTaskModel} from "../../models/fulfillment-task.model";
import {isMandatoryFlagKey} from "../../../orders/utils/identifications.util";

export class FulfillmentTaskFormCtrl implements IController {

  task: FulfillmentTaskModel;
  lineType: string;
  accountId: any;
  accountBranchIds: any[];
  depotOptionIds: any;
  identificationOptions: any;
  additionOptions: any;
  minDate: any;
  dateOptions: any;
  programType: any;
  notBefore: any;
  notAfter: any;
  isShowProxyCheckbox: boolean;
  isInvalidForm: boolean;
  isMarkerEnabled: any;
  attachments: any;
  onToggleCustomAddress: Function;
  onAddressChange: Function;
  onDateChange: Function;
  onChange: Function;
  onAttachmentsChange: Function;


  private configTimeZone: any;
  private customer: any;
  public siteInfo: any;
  private dateTypes: any;
  private selectedDateType: any;
  public minimumDate: any;
  public maximumDate: any;
  public selectedTimeSlot: any;
  public locationAccountOptionsIds: string[];
  public isTaskHoursWithinOperationHoursRange: boolean = true;
  public isPodAdditionsNotesSectionExpanded: boolean = false;
  public isAddressSectionExpanded: boolean = false;
  public taskIdentificationsList: string[] = [];
  public taskAdditionsList: string[] = [];
  public shortenedNote: string;
  public enableDisplayAllCustomers: boolean;

  public locationTypes: typeof LocationType = LocationType;
  public fulfillmentLineType: typeof FulfillmentLineType = FulfillmentLineType;

  constructor(private splitService, private moment, private $filter, private $log, private siteContextService: SiteContextService,
              private customersDialogService: CustomersDialogService, private customerService: CustomerService, private omsService: OmsService,
              private addressesService: AddressesService, private commonsDialogService: CommonsDialogService, private commonsConstants, private commonsService: CommonsService) {
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.dateTypes = ['timeWindow', 'appointment'];
    this.onlyValidPredicate = this.onlyValidPredicate.bind(this);
    this.enableDisplayAllCustomers = this.splitService.getOmsOrderEnableDisplayAllCustomers();
  }

  $onInit() {
    this.configTimeZone = this.splitService.getTimeZone();
    this.selectedDateType = this.task.schedulingRequired ? 'appointment' : this.dateTypes[0];

    if (this.programType) {
      this._getTaskTimeSlotOptions();
    }
    this._rebuildTaskIdentificationsList(this.task.identifications);
    this.taskAdditionsList = _.map(this.task.additions, 'name');

    if (this.task.notes) {
      this.shortenedNote = this.task.notes.split(' ').slice(0, 4).join(' ');
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.accountId) {
      this.locationAccountOptionsIds = this.accountId ? [this.accountId] : undefined;
    }
    if (changes.programType && !changes.programType.isFirstChange()) {
      this._getTaskTimeSlotOptions();
    }
    if (changes.dateOptions && !changes.dateOptions.isFirstChange()) {
      this.minimumDate = new Date(_.min(this.dateOptions));
      this.maximumDate = new Date(_.max(this.dateOptions));
    }
    if (changes.notBefore && !changes.notBefore.isFirstChange() ||
      changes.notAfter && !changes.notAfter.isFirstChange()) {

      const currentNotBefore = _.get(changes, 'notBefore.currentValue'),
        previousNotBefore = _.get(changes, 'notBefore.previousValue'),
        currentNotAfter = _.get(changes, 'notAfter.currentValue'),
        previousNotAfter = _.get(changes, 'notAfter.previousValue');

      if (((changes.notBefore && !previousNotBefore) || currentNotBefore && !this.moment(currentNotBefore).isSame(this.moment(previousNotBefore), 'day')) ||
        ((changes.notAfter && !previousNotAfter) || currentNotAfter && !this.moment(currentNotAfter).isSame(this.moment(previousNotAfter), 'day'))) {
        this.isTaskHoursWithinOperationHoursRange = true;
        this._getTaskTimeSlotOptions();
      }

    }
    if (changes.isInvalidForm && !changes.isInvalidForm.isFirstChange()) {
      if (this.isInvalidForm) {
        this.isAddressSectionExpanded = true;
      }
    }
  }

  onlyValidPredicate(date) {
    return !!_.filter(this.dateOptions, (day) => {
      return this._sameDay(new Date(day), date);
    }).length;
  }

  onLocationTypeChange(locationType) {
    this.customer = undefined;
    if (!this.task?.location) {
      this.task.location = {}
    }
    this.task.location.locationType = locationType;
    this.task.location.id = undefined;
    if (!this.task.contact) {
      this.task.contact = {}
    }
    this.task.contact.name = undefined;
    this.task.contact.businessName = undefined;
    this.task.contact.phoneNo = undefined;
    this.task.contact.email = undefined;
    this.task.contact.customerId = undefined;
    this.onChange();
  }

  onAccountSelect(account: AccountModel) {

    const isAccountChanged = !!this.task.location?.id && this.task.location.id !== account?.id;
    if (isAccountChanged || !this.task.notes) {
      this.task.notes = account?.note;
      this.shortenedNote = this.task.notes?.split(' ').slice(0, 4).join(' ');
    }

    if (!this.task.contact) {
      this.task.contact = {};
    }

    this.task.location.id = _.get(account, 'id');
    this.task.contact.name = _.get(account, 'name');
    this.task.contact.businessName = _.get(account, 'name');
    this.task.contact.phoneNo = _.get(account, 'phoneNumber');
    this.task.contact.additionalPhoneNo = this.$filter('bringozPhone')(_.get(account, 'additionalPhoneNo'));
    // this._setLocation(_.get(account, 'address'), !_.isUndefined(account) ? 'ACCOUNT' : 'UNDEFINED');
    this.onChange();
    if (account) {
      this._getTaskTimeSlotOptions();
    }
    this.onAddressChange({address: _.get(account, 'address')});
  }

  onDepotSelect(depot) {

    if (!this.task.contact) {
      this.task.contact = {};
    }

    this.task.location.id = _.get(depot, 'id');
    this.task.contact.name = _.get(depot, 'name');
    this.task.contact.businessName = _.get(depot, 'name');
    this.task.contact.phoneNo = _.get(depot, 'phoneNumber');
    this.task.contact.additionalPhoneNo = this.$filter('bringozPhone')(_.get(depot, 'additionalPhoneNo'));
    this.task.contact.customerId = undefined;
    // this._setLocation(_.get(depot, 'address'), !_.isUndefined(depot) ? 'DEPOT' : 'UNDEFINED');
    this._getTaskTimeSlotOptions();
    this.onChange();
    this.onAddressChange({address: _.get(depot, 'address')});
  }

  onCustomerSelect(customer) {

    if (!this.task.contact) {
      this.task.contact = {};
    }

    this.customer = customer;
    this.task.location.id = _.get(customer, 'id');
    this.task.contact.name = this._getCustomerName(customer);
    this.task.contact.businessName = _.get(customer, 'businessName');
    this.task.contact.phoneNo = _.get(customer, 'phone');
    this.task.contact.email = _.get(customer, 'email');
    this.task.contact.customerId = _.get(customer, 'id');
    // this.task.contact.additionalPhoneNo = _.get(customer, 'additionalPhoneNo');

    const address = _.find(_.get(customer, 'addresses', []), (a) => {
      return a.id === customer.defaultAddressId;
    })
    this.onAddressChange({address: address});
    this.onChange();
    this._getTaskTimeSlotOptions();
  }

  onSearchCustomerChange(searchText) {
    this.task.contact.name = searchText;
    if (!searchText) {
      this.task.contact = {};
      this.customer = undefined;
    }
  }

  onPhoneChange(phone) {
    this.task.contact.phoneNo = phone;
    this.onChange();
  }

  onAdditionalPhoneChange(additionalPhone) {
    this.task.contact.additionalPhoneNo = additionalPhone;

  }

  onAddAttachment() {
    this.commonsService.fileUpload(this.commonsConstants.fileConstants.upload.images)
      .then((result) => {
        this.afterUpload(result);
      })
      .catch(() => {
        this.$log.info('Closed File Upload')
      })
  }

  onRemoveAttachment(index) {
    this.attachments.splice(index, 1)
    this.onAttachmentsChange({attachments: this.attachments});
  }

  onAttachmentMouseEnter(index) {
    this.attachments[index].canRemove = true
  }

  onAttachmentMouseLeave(index) {
    this.attachments[index].canRemove = false
  }


  onSelectDateType(selectedDateType) {
    this.task.schedulingRequired = undefined;
    this.task.obligateTimeWindow = undefined;
    if (selectedDateType === 'timeWindow') {
      this.task.notBefore = this.moment().startOf('day').valueOf();
      this.task.notAfter = this.moment().endOf('day').valueOf();
      this._getTaskTimeSlotOptions();
    } else {
      this.task.notBefore = undefined;
      this.task.notAfter = undefined
      this.task.schedulingRequired = true;
    }
  }

  onNotBeforeDateChange(date) {
    if (!this.moment(date).isSame(this.moment(this.task.notBefore), 'day')) {
      this.task.notBefore = this.moment(date).startOf('day').valueOf();
      this._onNotBeforeChange();
      this._getTaskTimeSlotOptions();
    }
  }

  onNotBeforeTimeChange(notBefore) {
    if (!notBefore) {
      return;
    }
    this.task.notBefore = notBefore;
    this._onNotBeforeChange();
  }

  onLocationSelect(location) {
    if (!this.task.location) {
      this.task.location = {};
      this.task.location.address = {};
    }
    if(!this.task.location.address) {
      this.task.location.address = {};
    }
    this.task.location.address.location = this.addressesService.getAddressLocation(location.lat, location.lng);
  }

  onNotAfterDateChange(date) {
    if (!this.moment(date).isSame(this.moment(this.task.notAfter), 'day')) {
      this.task.notAfter = this.moment(date).startOf('day').valueOf();
      this._onNotAfterChange();
      this._getTaskTimeSlotOptions()
    }
  }

  onNotAfterTimeChange(notAfter) {
    if (!notAfter) {
      return;
    }

    this.task.notAfter = notAfter;
    this._onNotAfterChange();
  }

  onIdentificationsChange(identifications) {
    this.task.identifications = identifications;
    this._rebuildTaskIdentificationsList(identifications);
    this.onChange();
  }

  onAdditionsChange(additions) {
    this.task.additions = additions;
    this.taskAdditionsList = _.map(this.task.additions, 'name');
    this.onChange();
  }

  onNoteChange() {
    if (this.task.notes) {
      this.shortenedNote = this.task.notes.split(' ').slice(0, 4).join(' ');
    }
    this.onChange();
  }

  onCreateCustomer(customer, event) {
    this.customersDialogService.createCustomer(event, customer, this.accountId)
      .then((customerToCreate) => {
        this.createCustomer(customerToCreate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  private afterUpload(uploadedResult) {
    const imageUrl = _.get(uploadedResult, 'url'),
      mimeType = _.get(uploadedResult, 'contentType'),
      blobName = _.get(uploadedResult, 'blobName');

    if (imageUrl) {
      const attachment = {
        name: blobName,
        url: imageUrl,
        mimeType: mimeType
      };
      if (!this.attachments) {
        this.attachments = [];
      }
      this.attachments.push(attachment);
      this.onAttachmentsChange({attachments: this.attachments});
    }
  }


  private createCustomer(customer) {
    this.customerService.createCustomer(customer)
      .then((createdCustomer) => {
        this.onCustomerSelect(createdCustomer);
      })
  }

  // `identifications` is the backend-shaped map that mixes POD keys
  // (`signature`, `showIdCard`) with mandatory flags (`isSignatureFillRequired`).
  // This list is a UI-only projection of selected PODs, so mandatory flags
  // must be excluded. Rebuild from scratch on every call — callers used to
  // push without clearing, accumulating duplicates across saves.
  private _rebuildTaskIdentificationsList(identifications) {
    this.taskIdentificationsList = _.reduce(identifications, (acc, value, key) => {
      if (value && !isMandatoryFlagKey(key)) {
        acc.push(key);
      }
      return acc;
    }, [] as string[]);
  }

  private _onNotBeforeChange() {
    const minimumDateTimestamp = this.minimumDate ? this.moment(this.minimumDate).valueOf() : undefined;

    if (minimumDateTimestamp > this.task.notBefore) {
      this.task.notBefore = angular.copy(minimumDateTimestamp)
    }
    if (this.task.notBefore > this.task.notAfter) {
      this.task.notAfter = angular.copy(this.moment(this.task.notBefore).endOf('day').valueOf());
    }
    this.onDateChange({notBefore: this.task.notBefore, notAfter: this.task.notAfter});
  }

  private _onNotAfterChange() {
    const minimumDateTimestamp = this.minimumDate ? this.moment(this.minimumDate).valueOf() : undefined;

    if (minimumDateTimestamp > this.task.notAfter) {
      this.task.notAfter = angular.copy(minimumDateTimestamp)
    }
    if (this.task.notAfter < this.task.notBefore) {
      this.task.notBefore = angular.copy(this.task.notAfter);
    }
    this.onDateChange({notBefore: this.task.notBefore, notAfter: this.task.notAfter});
  }

  private _getCustomerName(customer) {
    return _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '');
  }

  private _sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

  private _getTaskTimeSlotOptions() {

    if (!_.get(this.task, 'location.address') || (!this.task.notBefore && !this.task.notAfter)) {
      return;
    }

    if (!this.task.schedulingRequired) {
      this.omsService.getOrderTaskTimeSlots(
        this.task.location.locationType === LocationType.ACCOUNT ? this.task.location.id : this.accountId,
        this.task.location.locationType === LocationType.DEPOT ? this.task.location.id : undefined,
        'Delivery', this.task.notBefore, this.task.notAfter, this.programType, this.configTimeZone)
        .then((timeSlotOptions: any) => {
          if (timeSlotOptions.length > 0) {
            this.selectedTimeSlot = angular.copy(timeSlotOptions[0]);
            this.task.notBefore = angular.copy(timeSlotOptions[0]).from;
            this.task.notAfter = angular.copy(timeSlotOptions[0]).to;
            this._onNotBeforeChange();
            this._onNotAfterChange();
          }
        }).catch(() => {

      })
    }
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentTaskForm', {
    require: {
      form: '^form'
    },
    bindings: {
      task: '<',
      lineType: '<',
      isOrigin: '<',
      accountId: '<?',
      accountBranchIds: '<?',
      depotOptionIds: '<?',
      identificationOptions: '<?',
      additionOptions: '<?',
      dateOptions: '<',
      programType: '<',
      minDate: '<?',
      notBefore: '<',
      notAfter: '<',
      isMarkerEnabled: '<?',
      isShowProxyCheckbox: '<',
      isInvalidForm: '<',
      attachments: '<?',
      onAttachmentsChange: '&',
      onToggleCustomAddress: '&',
      onAddressChange: '&',
      onChange: '&',
      onDateChange: '&',
    },
    template: require('./fulfillment-task-form.html').default,
    controller: FulfillmentTaskFormCtrl
  });
